/*
    Download Files
*/

window.exportFiles = function() {
    const css = window.css.of(window.customStyle);
    download(css, 'text/plain', 'customStyle.css');
    download(JSON.stringify(window.customJSON), 'text/json', 'customJson.json');
}


window.download = function(content, mimeType, filename){
    const a = document.createElement('a');
    const blob = new Blob([content], {type: mimeType});
    const url = URL.createObjectURL(blob);
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    a.click();
}

window.importFiles = function() {
    var el = window._protected_reference = document.createElement("INPUT");
    el.type = "file";
    el.accept = "text/css";
    el.multiple = "multiple"; // remove to have a single file selection
    // (cancel will not trigger 'change')
    el.addEventListener('change', function(ev2) {
        // test some async handling
        new Promise(function(resolve) {
            setTimeout(function() {
                const reader = new FileReader();
                reader.onload = function() {                    
                    var csstojson = cssToJson(reader.result);
                    
                    window.customStyle = csstojson;
                    window.styleElement.textContent = window.css.of(window.customStyle);
                    updateCss(csstojson);

                }
                reader.onerror = error => reject(error);
                reader.readAsText(el.files[0]);

                resolve();
            }, 1000);
        })
        .then(function() {
            // clear / free reference
            el = window._protected_reference = undefined;
        });
    });
    el.click(); // open
}


function cssToJson(cssStr) {
    var tmp = "";
    var openBraces = 0;
    for (var i = 0; i < cssStr.length; i++) {
        var c = cssStr[i];
        if (c == "{") { openBraces++; }
        else if ( c=="}" ){ openBraces--; }
        if ( openBraces==0 && c==":" ) {
            tmp += "_--_";
        } else {
            tmp += c;
        }
    }
    cssStr = tmp;
    cssStr = cssStr.split("\"").join("'");
    cssStr = cssStr.split(" ").join("_SPACE_");
    cssStr = cssStr.split("\r").join("");
    cssStr = cssStr.split("\n").join("");
    cssStr = cssStr.split("\t").join("");
    cssStr = cssStr.split("}").join("\"}####\"");
    cssStr = cssStr.split(";\"").join("\"");
    cssStr = cssStr.split(":").join("\":\"");
    cssStr = cssStr.split("{").join("\":{\"");
    cssStr = cssStr.split(";").join("\",\"");
    cssStr = cssStr.split("####").join(",");
    cssStr = cssStr.split("_--_").join(":");
    cssStr = cssStr.split("_SPACE_").join(" ");
    if (cssStr.endsWith(",")) {
        cssStr = cssStr.substr(0,cssStr.length-1);
    }
    if (cssStr.endsWith(",\"")) {
        cssStr = cssStr.substr(0,cssStr.length-2);
    }
    cssStr = "{\""+cssStr+"}";
    try{
        var jsn = JSON.parse(cssStr);
        return jsn;
    } catch(e){
        console.log(e);
        return null;
    }
}

function updateCss(csstojson) {

    var colors = [];
    var fonts = [];

    for (var elem in csstojson) {
        // console.log(elem);
        for (var attr in csstojson[elem]) {
            // Remove "!important" from the attribute value
            if (csstojson[elem][attr].includes("!important")) {
                var withoutImportant = csstojson[elem][attr].replace("!important", '');
                csstojson[elem][attr] = withoutImportant;
            }

            // Get Color and add them to the colors array
            if ((attr === "background-color") || (attr === "color")) {
                var noSpace = csstojson[elem][attr].replace(" ", "");
                csstojson[elem][attr] = noSpace;
                if (csstojson[elem][attr].charAt(0) != "#") {
                    if (!isInArray("transparent", csstojson[elem][attr])) {
                        var newHex =  rgbToHex(csstojson[elem][attr]);
                        csstojson[elem][attr] = newHex;
                        
                    }
                } else {
                    if (!isInArray(csstojson[elem][attr], colors)) {
                        colors.push(csstojson[elem][attr]);
                    }
                }
            }

            // Get Fonts and add them to the fonts array
            if ((attr === "font-family")) {
                var fontFamily = csstojson[elem]["font-family"];
                var fontSize = csstojson[elem]["font-size"];
                var fontColor = csstojson[elem]["color"];

                if(fontFamily.charAt(fontFamily.length - 1) == " ") {
                    fontFamily = fontFamily.slice(0, -1);
                }
                if (fontSize.includes("!important")) {
                    fontSize = fontSize.replace(" !important", "");
                }
                if (fontColor.includes("!important")) {
                    fontColor = fontColor.replace(" !important", "");
                }
                if (fontColor.charAt(0) != "#") {
                    if (!isInArray("transparent", fontColor)) {
                        fontColor =  rgbToHex(fontColor);
                    }
                } else {
                    var font = fontFamily + "_" + fontSize + "_" + fontColor;
                    if (!isInArray(font, fonts)) {
                        fonts.push(font);
                    }
                }
            }
        }
    }

    // Update Global Styles - Colors
    var colorsContainer = document.getElementById("colors-container");
    colorsContainer.replaceChildren();[];
    window.colors['colors'] = [];
    for (var id = 0; id < colors.length; id++) {
        var newColor = document.createElement("div");
        newColor.classList.add("color-settings","settings-sub-block-content-line");
        newColor.setAttribute("data-id", id);
        
        var newColorInfo = document.createElement('div');
        newColorInfo.classList.add("color-info");

        // Color Name
        var newColorName = document.createElement("input");
        newColorName.setAttribute("type", "text");
        newColorName.setAttribute("value", "imported "+id);
        newColorName.setAttribute("placeholder", "Add color name");
        newColorName.classList.add("color-name");
        newColorName.setAttribute("data-id", id);

        newColorName.addEventListener("change", function(event){
            var element = this;
            var idElement = element.getAttribute("data-id");
    
            var nameExists = false;
    
            window.colors.colors.forEach(function(obj, i){
                if (obj.settings.name == event.target.value) {
                    nameExists = true;
                }
            });
            
            if (!nameExists) {
                window.colors.colors.forEach(function(obj, i){
                    if (idElement == obj.id) {
                        obj.settings.name = event.target.value;
                    }
                });
            } else {
                alert("You can not repeat the name of the color.");
                newColorName.value = "";
            }
    
            window.updateColors();
        });

        // Color selection
        var newColorColor = document.createElement("input");
        newColorColor.setAttribute("type", "color");
        newColorColor.classList.add("color-color");
        newColorColor.setAttribute("data-id", id);
        newColorColor.value = colors[id];

        newColorColor.addEventListener("change", function(event){
            var element = this;
            var idElement = element.getAttribute("data-id");

            var textInput = element.nextSibling;
            textInput.value = event.target.value;

            window.colors.colors.forEach(function(obj, i){

                if (idElement == obj.id) {
                    obj.settings.color = event.target.value;
                }
            })
            window.updateColors();
        });

        // Color selection text
        var newColorColorText = document.createElement('input');
        newColorColorText.setAttribute("type", "text");
        newColorColorText.setAttribute("data-id", id);
        newColorColorText.setAttribute("value", colors[id]);
        newColorColorText.setAttribute("placeholder", "#000000");
        newColorColorText.classList.add("color-color-text");
        newColorColorText.addEventListener('change', function(event){
            var element = this;
            var idElement = element.getAttribute("data-id");

            var colorInput = element.previousSibling;
            colorInput.value = event.target.value;

            window.colors.colors.forEach(function(obj, i){
                if (idElement == obj.id) {
                    obj.settings.color = event.target.value;
                }
            })

            window.updateColors();
        })

        // Color Remove
        var newColorRemove = document.createElement("div");
        newColorRemove.classList.add("remove-color");
        newColorRemove.addEventListener('click', function(){
            var element = this;

            var idElement = element.parentNode.getAttribute("data-id");

            window.colors.colors.forEach(function(obj, i){

                if (idElement == obj.id) {
                    window.colors.colors.splice(i, 1);
                }
            })
            element.parentNode.remove();

            window.updateColors();
        })
        var newRemoveColorLogo = document.createElement("div");
        newRemoveColorLogo.classList.add("remove-color-logo");


        newColorInfo.append(newColorName);
        newColorInfo.append(newColorColor);
        newColorInfo.append(newColorColorText);
        newColor.append(newColorInfo);
        newColor.append(newColorRemove);
        newColorRemove.append(newRemoveColorLogo);

        colorsContainer.append(newColor);

        var newColorJSON = {
            "id": id,
            "settings": {
                "name": "imported "+id,
                "color": colors[id],
                "opacity": "100%"
            }
        };

        window.colors['colors'].push(newColorJSON);
        window.updateColors();
        
    }

    // Update Global Styles - Fonts
    var fontsContainer = document.getElementById("font-container");
    fontsContainer.replaceChildren();[];
    window.fonts['fonts'] = [];
    for (var id = 0; id < fonts.length; id++) {
        var font = fonts[id].split("_");
        
        var fontContainer = document.getElementById('font-container');

        var newFont = document.createElement('div');
        newFont.classList.add('font-settings');
        newFont.setAttribute('data-id', id);

        // Font Name
        var newFontName = document.createElement('p');
        var t = document.createTextNode('imported '+id);
        newFontName.classList.add('font-name'); 
        var newFontFamily = font[0].replace(" ", "+");

        var newStyleElement = document.createElement("link");
        newStyleElement.type = "text/css";
        newStyleElement.rel = "stylesheet";
        newStyleElement.href = "https://fonts.googleapis.com/css?family=" + newFontFamily;
        document.head.appendChild(newStyleElement);

        newFontName.style.fontFamily = font[0];
        newFontName.style.fontSize = font[1];
        newFontName.style.color = font[2];
        newFontName.append(t);

        // Font Logos Container
        var newFontLogos = document.createElement('div');
        newFontLogos.classList.add('font-logos');

        // Font Edit
        var newFontEdit = document.createElement('div');
        newFontEdit.setAttribute('data-id', id); 
        newFontEdit.classList.add('font-edit'); 

        newFontEdit.addEventListener('click', function(){
            var element = this;
            idFont = element.getAttribute('data-id');

            var fontConfig = document.getElementById('font-config');
            fontConfig.classList.add('show');

            window.fonts.fonts.forEach(function(obj, i) {
                if (idFont == obj.id) {
                    document.getElementById('font-config-name').value = obj.settings.name;
                    document.getElementById('font-config-size').value = obj.settings.size;
                    document.getElementById('font-config-line-height').value = obj.settings.lineHeight;
                    

                    var leftAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-left')[0];
                    var centerAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-center')[0];
                    var rightAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-right')[0];
                    if (obj.settings.textAlign == 'left') {
                        leftAlignmentContainer.classList.add('selected');
                        centerAlignmentContainer.classList.remove('selected');
                        rightAlignmentContainer.classList.remove('selected');
                    } else if (obj.settings.textAlign == 'center') {
                        leftAlignmentContainer.classList.remove('selected');
                        centerAlignmentContainer.classList.add('selected');
                        rightAlignmentContainer.classList.remove('selected');
                    } else if (obj.settings.textAlign == 'right') {
                        leftAlignmentContainer.classList.remove('selected');
                        centerAlignmentContainer.classList.remove('selected');
                        rightAlignmentContainer.classList.add('selected');
                    }

                    var fontSelect = document.getElementsByClassName('font-select')[0];
                    var fontSelectSpan = fontSelect.children[0];

                    document.getElementById("color-preview-font").style.backgroundColor = obj.settings.color;

                    for (var i = 0; i < window.colors.colors.length; i++) {
                        window.colors.colors[i].settings.color = window.colors.colors[i].settings.color.replace(" ", "");
                        obj.settings.color = obj.settings.color.replace(" ", "");
                        
                        if (window.colors.colors[i].settings.color == obj.settings.color) {
                            document.getElementById("font-color-selector").value = window.colors.colors[i].settings.name;
                        } else {
                            document.getElementById("font-color-selector").value = "No Color";
                        }
                    }

                    fontSelectSpan.innerHTML = obj.settings.fontFamily;
                    fontSelectSpan.style.fontFamily = obj.settings.fontFamily;
                    fontSelectSpan.style.fontWeight = obj.settings.fontWeight;


                }
            });
        })

        // Font Remove
        var newFontRemove = document.createElement("div");
        newFontRemove.classList.add("font-remove");
        newFontRemove.setAttribute('data-id', id);
        var newRemoveFontLogo = document.createElement("div");
        newRemoveFontLogo.classList.add("font-remove-logo");
        newFontRemove.append(newRemoveFontLogo);

        newFontRemove.addEventListener('click', function() {
            var element = this;

            var idElement = element.getAttribute("data-id");

            window.fonts.fonts.forEach(function(obj, i){

                if (idElement == obj.id) {
                    window.fonts.fonts.splice(i, 1);
                }
            })

            var fontConfig = document.getElementById("font-config");
            if(fontConfig.classList.contains("show")) {
                fontConfig.classList.remove("show");
            }

            element.parentNode.parentNode.remove();

            window.updateFonts();
        })

        newFont.append(newFontName);
        newFont.append(newFontLogos);
        newFontLogos.append(newFontEdit);
        newFontLogos.append(newFontRemove);
        fontContainer.append(newFont);

        var newFontJSON = {
            "id": id,
            "settings": {
                "name": "imported "+id,
                "fontFamily": font[0],
                "fontWeight": "400",
                "size": font[1],
                "color": font[2],
                "lineHeight": "auto",
                "textAlign": "left"
            }
        }

        window.fonts['fonts'].push(newFontJSON);

        window.updateFonts();
    }

    for (var elem in csstojson) {
        switch(elem) {
            case ".content":
                var colorContent = csstojson[elem]["background-color"];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorContent) {
                        document.getElementById('color-preview-background').style.backgroundColor = val.settings.color;
                        document.getElementById('background-color-selector').value = val.settings.name;
                        window.customStyle['.content']['background-color'] = val.settings.color + " !important";
                    }
                }
                break;
            case "header":
                // Color
                var colorHeader = csstojson[elem]["background-color"];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorHeader) {
                        document.getElementById('color-preview-header').style.backgroundColor = val.settings.color;
                        document.getElementById('background-header-color-selector').value = val.settings.name;
                        window.customStyle['header']['background-color'] = val.settings.color + " !important";
                    }
                }
                // Height
                document.getElementById("header-height").value = csstojson[elem].height;
                window.customStyle["header"]["height"] =  csstojson[elem].height + " !important";;
                window.customStyle[".content"]["height"] = "calc(100% - "+ csstojson[elem].height.replace("!important","")+") !important";
                // Border
                var borderHeader = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-header").value = borderHeader[0];
                var colorBorderHeader = borderHeader[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorBorderHeader) {
                        document.getElementById("color-border-preview-header").style.backgroundColor = val.settings.color;
                        document.getElementById('header-border-color-selector').value = val.settings.name;
                        window.customStyle['header']['border'] = csstojson[elem]["border"] + " !important";
                    }
                }
                // Shadow
                var shadowHeader = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("header-shadow-h-offset").value = shadowHeader[0];
                document.getElementById("header-shadow-v-offset").value = shadowHeader[1];
                document.getElementById("header-shadow-blur").value = shadowHeader[2];
                document.getElementById("header-shadow-spreed").value = shadowHeader[3];
                var colorShadowHeader = shadowHeader[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowHeader) {
                        document.getElementById("color-shadow-preview-color").style.backgroundColor = val.settings.color;
                        document.getElementById('header-shadow-color-selector').value = val.settings.name;
                        window.customStyle['header']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                    }
                }
                break;
            case ".logo":
                document.getElementById("logo-width").value = csstojson[elem].width;
                document.getElementById("logo-height").value = csstojson[elem].height;
                window.customStyle[".logo"]["width"] = csstojson[elem].width + " !important";
                window.customStyle[".logo"]["height"] = csstojson[elem].height + " !important";
                break;
            case ".bot-avatar":
                // Width
                document.getElementById("avatar-width").value = csstojson[elem].width;
                window.customStyle['.bot-avatar']['width'] = csstojson[elem].width + " !important";
                window.customStyle['#bot-neutral']['max-width'] = csstojson[elem].width + " !important";
                window.customStyle['#bot-emotion']['max-width'] = csstojson[elem].width + " !important";
                // Height
                document.getElementById("avatar-height").value = csstojson[elem].height;
                window.customStyle['.bot-avatar']['height'] = csstojson[elem].height + " !important";
                window.customStyle['#bot-neutral']['height'] = csstojson[elem].height + " !important";
                window.customStyle['#bot-emotion']['height'] = csstojson[elem].height + " !important";
                break;
            case ".container-payloads":
                // Alignment
                var leftAlignmentContainer = document.getElementsByClassName('menu-alignment-element-left')[0];
                var centerAlignmentContainer = document.getElementsByClassName('menu-alignment-element-center')[0];
                var rightAlignmentContainer = document.getElementsByClassName('menu-alignment-element-right')[0];
                if (csstojson[elem]["text-align"].includes("right")) {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.add('selected');
                    window.customStyle['.container-payloads']['text-align'] = "right !important";
                } else if (csstojson[elem]["text-align"].includes("center")) {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.add('selected');
                    rightAlignmentContainer.classList.remove('selected');
                    window.customStyle['.container-payloads']['text-align'] = "center !important";
                } else  {
                    leftAlignmentContainer.classList.add('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.remove('selected');
                    window.customStyle['.container-payloads']['text-align'] = "left !important";
                }
                // Background Color
                var containerPayloadColor = csstojson[elem]["background-color"];
                for (const val of window.colors.colors) {
                    if (val.settings.color == containerPayloadColor) {
                        document.getElementById("color-preview-menu-background").style.backgroundColor = val.settings.color;
                        document.getElementById('menu-background-color-selector').value = val.settings.name;
                        window.customStyle['.container-payloads']['background-color'] = csstojson[elem]["background-color"] + " !important";
                    }
                }
                break;
            case ".webchat-input":
                // Display
                var chatInputBtnActive = document.getElementById('chat-input-active');
                var chatInputBtnInactive = document.getElementById('chat-input-inactive');
                var chatInputContent = document.getElementById('chat-input-content');
                if (csstojson[elem]["display"] == "block") {
                    chatInputBtnActive.classList.add('selected');
                    chatInputBtnInactive.classList.remove('selected');
                    chatInputContent.style.display = "block";
                    window.customStyle[".webchat-input"]["display"] = "block";
                } else {
                    chatInputBtnActive.classList.remove('selected');
                    chatInputBtnInactive.classList.add('selected');
                    chatInputContent.style.display = "none";
                    window.customStyle[".webchat-input"]["display"] = "none";
                }
                // Size
                document.getElementById("chat-input-width").value = csstojson[elem]["width"];
                window.customStyle[".webchat-input"]["width"] = csstojson[elem]["width"] + " !important";
                document.getElementById("chat-input-height").value = csstojson[elem]["height"];
                window.customStyle[".webchat-input"]["height"] = csstojson[elem]["height"] + " !important";
                // Alignment
                var leftAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-left')[0];
                var centerAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-center')[0];
                var rightAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-right')[0];
                if (csstojson[elem]["align-self"].includes("center")) {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.add('selected');
                    rightAlignmentContainer.classList.remove('selected');
                    window.customStyle['.webchat-input']['align-self'] = "center !important";
                } else if (csstojson[elem]["align-self"].includes("flex-end")) {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.add('selected');
                    window.customStyle['.webchat-input']['align-self'] = "flex-end !important";
                } else {
                    leftAlignmentContainer.classList.add('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.remove('selected');
                    window.customStyle['.webchat-input']['align-self'] = "flex-start !important";
                }
                // Background Color
                var webchatInputColor = csstojson[elem]["background"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == webchatInputColor) {
                        document.getElementById('color-preview-chat-input').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-input-color-selector').value = val.settings.name;
                        window.customStyle['.webchat-input']['background'] = csstojson[elem]["background"] + " !important";
                    }
                }
                // Corner Radius
                document.getElementById("corner-radius-topL-chat-input").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".webchat-input"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                document.getElementById("corner-radius-topR-chat-input").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".webchat-input"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                document.getElementById("corner-radius-bottomL-chat-input").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".webchat-input"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                document.getElementById("corner-radius-bottomR-chat-input").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".webchat-input"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                // Border
                var webchatInputBorder = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-chat-input").value = webchatInputBorder[0];
                var colorWebchatInputBorder = webchatInputBorder[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorWebchatInputBorder) {
                        document.getElementById("color-border-preview-chat-input").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-input-border-color-selector').value = val.settings.name;
                        window.customStyle['.webchat-input']['border'] = csstojson[elem]["border"] + " !important";
                    }
                }
                // Shadow
                var shadowHeader = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("chat-input-shadow-h-offset").value = shadowHeader[0];
                document.getElementById("chat-input-shadow-v-offset").value = shadowHeader[1];
                document.getElementById("chat-input-shadow-blur").value = shadowHeader[2];
                document.getElementById("chat-input-shadow-spreed").value = shadowHeader[3];
                var colorShadowWebchatInput = shadowHeader[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowWebchatInput) {
                        document.getElementById("color-shadow-preview-color-chat-input").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-input-shadow-color-selector').value = val.settings.name;
                        window.customStyle['.webchat-input']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                    }
                }
                break;
            case ".webchat-input-message-input":
                var webchatInputColorText = csstojson[elem]["color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == webchatInputColorText) {
                        document.getElementById('color-preview-text-chat-input').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-input-text-color-selector').value = val.settings.name;
                        window.customStyle['.webchat-input-message-input']['color'] = csstojson[elem]["color"] + " !important";
                        window.customStyle['.webchat-input-message-input::-webkit-input-placeholder']['color'] = csstojson[elem]["color"] + " !important";
                    }
                }
                break;
            case ".regular-message.bot":
                // Background Color
                var colorBot = csstojson[elem]["background"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorBot) {
                        document.getElementById('color-preview-chat-bubble-bot').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-bot-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.bot']['background'] = val.settings.color + " !important";
                        window.customStyle['.BorderBubble']['background'] = val.settings.color + " !important";
                    }
                }
                // Text Color
                var colorTextBot = csstojson[elem]["color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorTextBot) {
                        document.getElementById('color-text-preview-chat-bubble-bot').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-bot-text-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.bot']['color'] = val.settings.color + " !important";
                        window.customStyle['.BorderBubble']['color'] = val.settings.color + " !important";
                    }
                }
                // Corner Radius
                document.getElementById("corner-radius-topL-chat-bubble-bot").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".regular-message.bot"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                window.customStyle[".BorderBubble"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"];
                document.getElementById("corner-radius-topR-chat-bubble-bot").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".regular-message.bot"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                window.customStyle[".BorderBubble"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"];
                document.getElementById("corner-radius-bottomL-chat-bubble-bot").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".regular-message.bot"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                window.customStyle[".BorderBubble"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"];
                document.getElementById("corner-radius-bottomR-chat-bubble-bot").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".regular-message.bot"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                window.customStyle[".BorderBubble"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"];
                // Padding
                document.getElementById("padding-top-chat-bubble-bot").value = csstojson[elem]["padding-top"];
                window.customStyle[".regular-message.bot"]["padding-top"] = csstojson[elem]["padding-top"] + " !important";
                window.customStyle[".BorderBubble"]["padding-top"] = csstojson[elem]["padding-top"];
                document.getElementById("padding-bottom-chat-bubble-bot").value = csstojson[elem]["padding-bottom"];
                window.customStyle[".regular-message.bot"]["padding-bottom"] = csstojson[elem]["padding-bottom"] + " !important";
                window.customStyle[".BorderBubble"]["padding-bottom"] = csstojson[elem]["padding-bottom"];
                document.getElementById("padding-left-chat-bubble-bot").value = csstojson[elem]["padding-left"];
                window.customStyle[".regular-message.bot"]["padding-left"] = csstojson[elem]["padding-left"] + " !important";
                window.customStyle[".BorderBubble"]["padding-left"] = csstojson[elem]["padding-left"];
                document.getElementById("padding-right-chat-bubble-bot").value = csstojson[elem]["padding-right"];
                window.customStyle[".regular-message.bot"]["padding-right"] = csstojson[elem]["padding-right"] + " !important";
                window.customStyle[".BorderBubble"]["padding-right"] = csstojson[elem]["padding-right"];
                // Margin
                document.getElementById("margin-top-chat-bubble-bot").value = csstojson[elem]["margin-top"];
                window.customStyle[".regular-message.bot"]["margin-top"] = csstojson[elem]["margin-top"] + " !important";
                window.customStyle[".BorderBubble"]["margin-top"] = csstojson[elem]["margin-top"];
                document.getElementById("margin-bottom-chat-bubble-bot").value = csstojson[elem]["margin-bottom"];
                window.customStyle[".regular-message.bot"]["margin-bottom"] = csstojson[elem]["margin-bottom"] + " !important";
                window.customStyle[".BorderBubble"]["margin-bottom"] = csstojson[elem]["margin-bottom"];
                document.getElementById("margin-left-chat-bubble-bot").value = csstojson[elem]["margin-left"];
                window.customStyle[".regular-message.bot"]["margin-left"] = csstojson[elem]["margin-left"] + " !important";
                window.customStyle[".BorderBubble"]["margin-left"] = csstojson[elem]["margin-left"];
                document.getElementById("margin-right-chat-bubble-bot").value = csstojson[elem]["margin-right"];
                window.customStyle[".regular-message.bot"]["margin-right"] = csstojson[elem]["margin-right"] + " !important";
                window.customStyle[".BorderBubble"]["margin-right"] = csstojson[elem]["margin-right"];
                // Border
                var botBorder = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-chat-bubble-bot").value = botBorder[0];
                var colorBotBorder = botBorder[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorBotBorder) {
                        document.getElementById("color-border-preview-chat-bubble-bot").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-bot-border-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.bot']['border'] = csstojson[elem]["border"] + " !important";
                        window.customStyle['.BorderBubble']['border'] = csstojson[elem]["border"];
                    }
                }
                // Shadow
                var shadowBot = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("chat-bubble-bot-shadow-h-offset").value = shadowBot[0];
                document.getElementById("chat-bubble-bot-shadow-v-offset").value = shadowBot[1];
                document.getElementById("chat-bubble-bot-shadow-blur").value = shadowBot[2];
                document.getElementById("chat-bubble-bot-shadow-spreed").value = shadowBot[3];
                var colorShadowBot = shadowBot[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowBot) {
                        document.getElementById("color-shadow-preview-color-chat-bubble-bot").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-bot-shadow-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.bot']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                        window.customStyle['.BorderBubble']['box-shadow'] = csstojson[elem]["box-shadow"];
                    }
                }
                break;
            case ".regular-message.user":
                // Background Color
                var colorUser = csstojson[elem]["background"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorUser) {
                        document.getElementById('color-preview-chat-bubble-user').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-user-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.user']['background'] = val.settings.color + " !important";
                    }
                }
                // Text Color
                var colorTextUser = csstojson[elem]["color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorTextUser) {
                        document.getElementById('color-text-preview-chat-bubble-user').style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-user-text-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.user']['color'] = val.settings.color + " !important";
                    }
                }
                // Corner Radius
                document.getElementById("corner-radius-topL-chat-bubble-user").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".regular-message.user"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                document.getElementById("corner-radius-topR-chat-bubble-user").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".regular-message.user"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                document.getElementById("corner-radius-bottomL-chat-bubble-user").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".regular-message.user"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                document.getElementById("corner-radius-bottomR-chat-bubble-user").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".regular-message.user"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                // Padding
                document.getElementById("padding-top-chat-bubble-user").value = csstojson[elem]["padding-top"];
                window.customStyle[".regular-message.user"]["padding-top"] = csstojson[elem]["padding-top"] + " !important";
                document.getElementById("padding-bottom-chat-bubble-user").value = csstojson[elem]["padding-bottom"];
                window.customStyle[".regular-message.user"]["padding-bottom"] = csstojson[elem]["padding-bottom"] + " !important";
                document.getElementById("padding-left-chat-bubble-user").value = csstojson[elem]["padding-left"];
                window.customStyle[".regular-message.user"]["padding-left"] = csstojson[elem]["padding-left"] + " !important";
                document.getElementById("padding-right-chat-bubble-user").value = csstojson[elem]["padding-right"];
                window.customStyle[".regular-message.user"]["padding-right"] = csstojson[elem]["padding-right"] + " !important";
                // Margin
                document.getElementById("margin-top-chat-bubble-user").value = csstojson[elem]["margin-top"];
                window.customStyle[".regular-message.user"]["margin-top"] = csstojson[elem]["margin-top"] + " !important";
                document.getElementById("margin-bottom-chat-bubble-user").value = csstojson[elem]["margin-bottom"];
                window.customStyle[".regular-message.user"]["margin-bottom"] = csstojson[elem]["margin-bottom"] + " !important";
                document.getElementById("margin-left-chat-bubble-user").value = csstojson[elem]["margin-left"];
                window.customStyle[".regular-message.user"]["margin-left"] = csstojson[elem]["margin-left"] + " !important";
                document.getElementById("margin-right-chat-bubble-user").value = csstojson[elem]["margin-right"];
                window.customStyle[".regular-message.user"]["margin-right"] = csstojson[elem]["margin-right"] + " !important";
                // Border
                var userBorder = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-chat-bubble-user").value = userBorder[0];
                var colorUserBorder = userBorder[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorUserBorder) {
                        document.getElementById("color-border-preview-chat-bubble-user").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-user-border-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.user']['border'] = csstojson[elem]["border"] + " !important";
                    }
                }
                // Shadow
                var shadowUser = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("chat-bubble-user-shadow-h-offset").value = shadowUser[0];
                document.getElementById("chat-bubble-user-shadow-v-offset").value = shadowUser[1];
                document.getElementById("chat-bubble-user-shadow-blur").value = shadowUser[2];
                document.getElementById("chat-bubble-user-shadow-spreed").value = shadowUser[3];
                var colorShadowUser = shadowUser[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowUser) {
                        document.getElementById("color-shadow-preview-color-chat-bubble-user").style.backgroundColor = val.settings.color;
                        document.getElementById('chat-bubble-user-shadow-color-selector').value = val.settings.name;
                        window.customStyle['.regular-message.user']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                    }
                }
                break;
            case ".MessengerQuickReply":
                // Background Color
                var colorQuickReply = csstojson[elem]["background"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorQuickReply) {
                        document.getElementById('color-preview-quick-reply').style.backgroundColor = val.settings.color;
                        document.getElementById('quick-reply-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerQuickReply']['background'] = val.settings.color + " !important";
                    }
                }
                // Text Color
                var colorTextQuickReply = csstojson[elem]["color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorTextQuickReply) {
                        document.getElementById('color-preview-text-quick-reply').style.backgroundColor = val.settings.color;
                        document.getElementById('quick-reply-text-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerQuickReply']['color'] = val.settings.color + " !important";
                    }
                }
                // Font Type
                window.customStyle[".MessengerQuickReply"]["font-family"] = csstojson[elem]["font-family"] + " !important";
                // Corner Radius
                document.getElementById("corner-radius-topL-quick-reply").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".MessengerQuickReply"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                document.getElementById("corner-radius-topR-quick-reply").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".MessengerQuickReply"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                document.getElementById("corner-radius-bottomL-quick-reply").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".MessengerQuickReply"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                document.getElementById("corner-radius-bottomR-quick-reply").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".MessengerQuickReply"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                // Padding
                document.getElementById("padding-top-quick-reply").value = csstojson[elem]["padding-top"];
                window.customStyle[".MessengerQuickReply"]["padding-top"] = csstojson[elem]["padding-top"] + " !important";
                document.getElementById("padding-bottom-quick-reply").value = csstojson[elem]["padding-bottom"];
                window.customStyle[".MessengerQuickReply"]["padding-bottom"] = csstojson[elem]["padding-bottom"] + " !important";
                document.getElementById("padding-left-quick-reply").value = csstojson[elem]["padding-left"];
                window.customStyle[".MessengerQuickReply"]["padding-left"] = csstojson[elem]["padding-left"] + " !important";
                document.getElementById("padding-right-quick-reply").value = csstojson[elem]["padding-right"];
                window.customStyle[".MessengerQuickReply"]["padding-right"] = csstojson[elem]["padding-right"] + " !important";
                // Margin
                document.getElementById("margin-top-quick-reply").value = csstojson[elem]["margin-top"];
                window.customStyle[".MessengerQuickReply"]["margin-top"] = csstojson[elem]["margin-top"] + " !important";
                document.getElementById("margin-bottom-quick-reply").value = csstojson[elem]["margin-bottom"];
                window.customStyle[".MessengerQuickReply"]["margin-bottom"] = csstojson[elem]["margin-bottom"] + " !important";
                document.getElementById("margin-left-quick-reply").value = csstojson[elem]["margin-left"];
                window.customStyle[".MessengerQuickReply"]["margin-left"] = csstojson[elem]["margin-left"] + " !important";
                document.getElementById("margin-right-quick-reply").value = csstojson[elem]["margin-right"];
                window.customStyle[".MessengerQuickReply"]["margin-right"] = csstojson[elem]["margin-right"] + " !important";
                // Border
                var quickReplyBorder = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-quick-reply").value = quickReplyBorder[0];
                var colorquickReplyBorder = quickReplyBorder[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorquickReplyBorder) {
                        document.getElementById("color-border-preview-quick-reply").style.backgroundColor = val.settings.color;
                        document.getElementById('quick-reply-border-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerQuickReply']['border'] = csstojson[elem]["border"] + " !important";
                    }
                }
                // Shadow
                var shadowQuickReply = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("quick-reply-shadow-h-offset").value = shadowQuickReply[0];
                document.getElementById("quick-reply-shadow-v-offset").value = shadowQuickReply[1];
                document.getElementById("quick-reply-shadow-blur").value = shadowQuickReply[2];
                document.getElementById("quick-reply-shadow-spreed").value = shadowQuickReply[3];
                var colorShadowQuickReply = shadowQuickReply[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowQuickReply) {
                        document.getElementById("color-shadow-preview-color-quick-reply").style.backgroundColor = val.settings.color;
                        document.getElementById('quick-reply-shadow-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerQuickReply']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                    }
                }
                break;
            case ".MessengerButton":
                // Background Color
                var colorButton = csstojson[elem]["background"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorButton) {
                        document.getElementById('color-preview-link-button').style.backgroundColor = val.settings.color;
                        document.getElementById('link-button-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerButton']['background'] = val.settings.color + " !important";
                    }
                }
                // Text Color
                var colorTextLinkButton = csstojson[elem]["color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorTextLinkButton) {
                        document.getElementById('color-preview-text-link-button').style.backgroundColor = val.settings.color;
                        document.getElementById('link-button-text-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerButton']['color'] = val.settings.color + " !important";
                    }
                }
                // Corner Radius
                document.getElementById("corner-radius-topL-link-button").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".MessengerButton"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                document.getElementById("corner-radius-topR-link-button").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".MessengerButton"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                document.getElementById("corner-radius-bottomL-link-button").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".MessengerButton"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                document.getElementById("corner-radius-bottomR-link-button").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".MessengerButton"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                // Padding
                document.getElementById("padding-top-link-button").value = csstojson[elem]["padding-top"];
                window.customStyle[".MessengerButton"]["padding-top"] = csstojson[elem]["padding-top"] + " !important";
                document.getElementById("padding-bottom-link-button").value = csstojson[elem]["padding-bottom"];
                window.customStyle[".MessengerButton"]["padding-bottom"] = csstojson[elem]["padding-bottom"] + " !important";
                document.getElementById("padding-left-link-button").value = csstojson[elem]["padding-left"];
                window.customStyle[".MessengerButton"]["padding-left"] = csstojson[elem]["padding-left"] + " !important";
                document.getElementById("padding-right-link-button").value = csstojson[elem]["padding-right"];
                window.customStyle[".MessengerButton"]["padding-right"] = csstojson[elem]["padding-right"] + " !important";
                // Margin
                document.getElementById("margin-top-link-button").value = csstojson[elem]["margin-top"];
                window.customStyle[".MessengerButton"]["margin-top"] = csstojson[elem]["margin-top"] + " !important";
                document.getElementById("margin-bottom-link-button").value = csstojson[elem]["margin-bottom"];
                window.customStyle[".MessengerButton"]["margin-bottom"] = csstojson[elem]["margin-bottom"] + " !important";
                document.getElementById("margin-left-link-button").value = csstojson[elem]["margin-left"];
                window.customStyle[".MessengerButton"]["margin-left"] = csstojson[elem]["margin-left"] + " !important";
                document.getElementById("margin-right-link-button").value = csstojson[elem]["margin-right"];
                window.customStyle[".MessengerButton"]["margin-right"] = csstojson[elem]["margin-right"] + " !important";
                // Border
                var linkButtonBorder = csstojson[elem]["border"].split(" ");
                document.getElementById("width-border-link-button").value = linkButtonBorder[0];
                var colorlinkButtonBorder = linkButtonBorder[2];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorlinkButtonBorder) {
                        document.getElementById("color-border-preview-link-button").style.backgroundColor = val.settings.color;
                        document.getElementById('link-button-border-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerButton']['border'] = csstojson[elem]["border"] + " !important";
                    }
                }
                // Shadow
                var shadowLinkButton = csstojson[elem]["box-shadow"].split(" ");
                document.getElementById("link-button-shadow-h-offset").value = shadowLinkButton[0];
                document.getElementById("link-button-shadow-v-offset").value = shadowLinkButton[1];
                document.getElementById("link-button-shadow-blur").value = shadowLinkButton[2];
                document.getElementById("link-button-shadow-spreed").value = shadowLinkButton[3];
                var colorShadowLinkButton = shadowLinkButton[4];
                for (const val of window.colors.colors) {
                    if (val.settings.color == colorShadowLinkButton) {
                        document.getElementById("color-shadow-preview-color-link-button").style.backgroundColor = val.settings.color;
                        document.getElementById('link-button-shadow-color-selector').value = val.settings.name;
                        window.customStyle['.MessengerButton']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                    }
                }
                window.customStyle['.MessengerButton']['display'] = csstojson[elem]["display"] + " !important";
                window.customStyle['.MessengerButton']['width'] = csstojson[elem]["width"] + " !important";
                break;
            case ".MessengerFrame":
                window.customStyle['.MessengerFrame']['background-color'] = csstojson[elem]["background-color"] + " !important";
                window.customStyle['.MessengerFrame']['border-radius'] = csstojson[elem]["border-radius"] + " !important";
                window.customStyle['.MessengerFrame']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                window.customStyle['.MessengerFrame']['width'] = csstojson[elem]["width"] + " !important";
                break;
            case ".MessengerFrameMedia":
                // Size
                document.getElementById("image-video-width").value = csstojson[elem]["width"];
                window.customStyle[".MessengerFrameMedia"]["width"] = csstojson[elem]["width"] + " !important";
                document.getElementById("image-video-height").value = csstojson[elem]["height"];
                window.customStyle[".MessengerFrameMedia"]["height"] = csstojson[elem]["height"] + " !important";
                // Corner Radius
                document.getElementById("corner-radius-topL-image-video").value = csstojson[elem]["border-top-left-radius"];
                window.customStyle[".MessengerFrameMedia"]["border-top-left-radius"] = csstojson[elem]["border-top-left-radius"] + " !important";
                document.getElementById("corner-radius-topR-image-video").value = csstojson[elem]["border-top-right-radius"];
                window.customStyle[".MessengerFrameMedia"]["border-top-right-radius"] = csstojson[elem]["border-top-right-radius"] + " !important";
                document.getElementById("corner-radius-bottomL-image-video").value = csstojson[elem]["border-bottom-left-radius"];
                window.customStyle[".MessengerFrameMedia"]["border-bottom-left-radius"] = csstojson[elem]["border-bottom-left-radius"] + " !important";
                document.getElementById("corner-radius-bottomR-image-video").value = csstojson[elem]["border-bottom-right-radius"];
                window.customStyle[".MessengerFrameMedia"]["border-bottom-right-radius"] = csstojson[elem]["border-bottom-right-radius"] + " !important";
                // Margin
                document.getElementById("margin-top-image-video").value = csstojson[elem]["margin-top"];
                window.customStyle[".MessengerFrameMedia"]["margin-top"] = csstojson[elem]["margin-top"] + " !important";
                document.getElementById("margin-bottom-image-video").value = csstojson[elem]["margin-bottom"];
                window.customStyle[".MessengerFrameMedia"]["margin-bottom"] = csstojson[elem]["margin-bottom"] + " !important";
                document.getElementById("margin-left-image-video").value = csstojson[elem]["margin-left"];
                window.customStyle[".MessengerFrameMedia"]["margin-left"] = csstojson[elem]["margin-left"] + " !important";
                document.getElementById("margin-right-image-video").value = csstojson[elem]["margin-right"];
                window.customStyle[".MessengerFrameMedia"]["margin-right"] = csstojson[elem]["margin-right"] + " !important";
                break;
            case ".cognigy-webchat-1mv2cde":
                // Background Color
                var galleryColor = csstojson[elem]["background-color"].replace(" ", "");
                for (const val of window.colors.colors) {
                    if (val.settings.color == galleryColor) {
                        document.getElementById('color-preview-gallery').style.backgroundColor = val.settings.color;
                        document.getElementById('gallery-color-selector').value = val.settings.name;
                        window.customStyle['.cognigy-webchat-1mv2cde']['background-color'] = csstojson[elem]["background-color"] + " !important";
                    }
                }
                break;
            case ".cognigy-webchat-kifjyg":
                window.customStyle['.cognigy-webchat-kifjyg']['box-shadow'] = csstojson[elem]["box-shadow"] + " !important";
                window.customStyle['.cognigy-webchat-kifjyg']['background-color'] = "transparent !important";
                break;
            case ".cognigy-webchat-orcf8t":
                window.customStyle['.cognigy-webchat-orcf8t']['border-bottom'] = csstojson[elem]["border-bottom"] + " !important";
                break;
            case ".cognigy-webchat-12tlige":
                window.customStyle['.cognigy-webchat-12tlige']['color'] = csstojson[elem]["color"] + " !important";
                window.customStyle['.cognigy-webchat-12tlige']['font-family'] = csstojson[elem]["font-family"] + " !important";
                window.customStyle['.cognigy-webchat-12tlige']['font-size'] = csstojson[elem]["font-size"] + " !important";
                break;
            case ".cognigy-webchat-14qz9ku":
                window.customStyle['.cognigy-webchat-14qz9ku']['color'] = csstojson[elem]["color"] + " !important";
                window.customStyle['.cognigy-webchat-14qz9ku']['font-family'] = csstojson[elem]["font-family"] + " !important";
                window.customStyle['.cognigy-webchat-14qz9ku']['font-size'] = csstojson[elem]["font-size"] + " !important";
                break;          
            default:
                //console.log(elem);
        }
    }

    window.styleElement.textContent = window.css.of(window.customStyle);
}

function isInArray(value, array) {
    return array.indexOf(value) > -1;
}

function rgbToHex(rgb) {
    var rgb = rgb.replace("rgb(", "");
    rgb = rgb.replace(")", "");
    rgb = rgb.replace(" ", "");

    var hex = rgb.split(",");
    
    let hr = Math.max(0, Math.min(255, Math.round(hex[0]))).toString(16);
    let hg = Math.max(0, Math.min(255, Math.round(hex[1]))).toString(16);
    let hb = Math.max(0, Math.min(255, Math.round(hex[2]))).toString(16);
    return "#" + (hr.length<2?"0":"") + hr + (hg.length<2?"0":"") + hg + (hb.length<2?"0":"") + hb;
}

function equals(a, b) {
    const aKeys = Object.keys(a)
    const bKeys = Object.keys(b)
    if(aKeys.length != bKeys.length) {
        return false
    }
    for(let i = 0;i < aKeys.length;i++) {
        if(aKeys[i] != bKeys[i]) {
            return false
        } 
    }
    for(let i = 0;i < aKeys.length;i++) {
        if(a[aKeys[i]] != b[bKeys[i]]) {
            return false
        }
    }
    return true
}